var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`block mx-${_vm.spacing} ${_vm.extraClassName}`,on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('img',{class:`h-${_vm.size} w-${_vm.size} opacity-50 hover:opacity-100`,attrs:{"src":'/icons/actions/'+_vm.icon+'.svg'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }